import {createLazyFileRoute} from '@tanstack/react-router'

import FlightDetails from '@/views/Account/Flights/FlightDetails'

export const Route = createLazyFileRoute('/_account/flight-bookings/$bookingId/')({
  component: FlightDetails,
})
